import { effectivePhase } from './deal-phase.mjs';

import { isActionChecked } from './crm/checklist.mjs';
export { isActionChecked } from './crm/checklist.mjs';
export function phaseKeyOf(phaseIdx, action) { return `${phaseIdx}:${action}`; }

export function processPhaseProgress(deal, phaseData) {
  const phases = phaseData[deal.track];
  if (!phases) return null;
  const pc = deal.phaseChecklist || { phaseIndex: 0, actions: {} };
  const { stored, floor, index: phaseIndex, skipped } = effectivePhase(deal, phases);
  const phase = phases[phaseIndex];
  const actions = pc.actions || {};
  const done = phase.actions.filter(a => isActionChecked(actions, phaseIndex, a)).length;
  const total = phase.actions.length;
  return { phaseIndex, storedIndex: stored, floor, skipped, phase, done, total, isLast: phaseIndex === phases.length - 1, allDone: done === total, totalPhases: phases.length, phases };
}


export function processChance(deal, phaseData, now = Date.now()) {
  if (!deal) return 0;
  if (deal.signed) return 100; // a signed contract is a 100% certain placement
  const prog = processPhaseProgress(deal, phaseData);
  if (!prog) return 0;
  const { phaseIndex, done, total, totalPhases } = prog;
  const inPhase = total > 0 ? done / total : 0;
  const phaseRatio = (phaseIndex + inPhase) / Math.max(1, totalPhases);
  let kans = Math.round(phaseRatio * 60);
  if (deal.track === 'placement') {
    const boost = { 'IV1': 8, 'IV2': 20, 'IV3': 32, 'IV4': 36, 'IV5': 39, 'IV6': 41, 'Aanbieding arbeidscontract': 42 };
    kans += boost[deal.status] || 0;
  } else if (deal.track === 'bd') {
    const boost = { 'Lead': 0, 'Voorstel NCNP': 12, 'Voorstel Retained': 16, 'Voorstel Partnership': 20, 'Vragen over Raamovereenkomst': 28 };
    kans += boost[deal.status] || 0;
  }
  if (!deal.signed && !deal.archived) {
    const created = deal.createdAt ? new Date(deal.createdAt).getTime() : now;
    const ageDays = Math.max(0, Math.floor((now - created) / 86400000));
    if      (ageDays > 90) kans -= 22;
    else if (ageDays > 60) kans -= 14;
    else if (ageDays > 30) kans -= 7;
    else if (ageDays > 14) kans -= 3;
  }
  const reschedules = (deal.rescheduleLog || []).length;
  kans -= reschedules * 5;
  if (deal.signed) return 100;
  return Math.max(0, Math.min(100, kans));
}


export function weightedProcessFee(fee, deal, phaseData, now = Date.now()) {
  const kans = processChance(deal, phaseData, now);
  return { kans, weighted: Math.round(fee * kans / 100) };
}
